import type { CSSProperties } from 'react';

// Shared icon props. All stroke icons render at currentColor, so size + color
// are controlled by the caller via className / style.
export interface IconProps {
  className?: string;
  style?: CSSProperties;
  strokeWidth?: number;
}

function StrokeIcon({ className, style, strokeWidth = 2, d }: IconProps & { d: string }) {
  return (
    <svg className={className} style={style} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokeWidth} d={d} />
    </svg>
  );
}

export const ClockIcon = (p: IconProps) => (
  <StrokeIcon {...p} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
);
export const ItemsIcon = (p: IconProps) => (
  <StrokeIcon {...p} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
);
export const RebuildIcon = (p: IconProps) => (
  <StrokeIcon {...p} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
);
export const WarningIcon = (p: IconProps) => (
  <StrokeIcon {...p} d="M12 9v2m0 4h.01M5.07 19h13.86a2 2 0 001.74-3L13.74 4a2 2 0 00-3.48 0L3.34 16a2 2 0 001.73 3z" />
);
export const SearchIcon = (p: IconProps) => (
  <StrokeIcon {...p} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
);
export const PlusIcon = (p: IconProps) => (
  <StrokeIcon {...p} d="M12 4v16m8-8H4" />
);
export const KeyIcon = (p: IconProps) => (
  <StrokeIcon {...p} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
);

// Indeterminate spinner. Size via className (default w-3 h-3).
export function Spinner({ className = 'w-3 h-3' }: { className?: string }) {
  return <span className={`${className} rounded-full border-2 border-blue-400 border-t-transparent animate-spin`} />;
}
